module.exports = __webpack_public_path__ + "static/media/home.5291e605.png";